import { Form, Rate, Select } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Swal from 'sweetalert2';
import { defaultTableState } from '../../core-module/models/redux/DefaultTableState';
import { fetchTable, setLoading } from '../../core-module/redux/Table/actions';
import ReviewEndpoint from '../../core-module/models/LoopBack/Models/ReviewEndpoint';
import FormHeader from '../../components/Form/Header';
import { DefaultAuthState } from '../../core-module/models/redux/DefaultAuthState';
import { TextAreaWithCharacterCount } from '../../components/TextAreaWithCharacterCount';
import { websiteClient } from '../../core-module/services/website/WebsiteClient';

interface Props extends FormComponentProps {
  rowData: any;
  auth: DefaultAuthState;
  stateKey: number | string;
  state: typeof defaultTableState;
  fetchTable: (stateKey, endPoint, filters) => void;
  setLoading: (stateKey, loading) => void;
  loopBackEndpoint: ReviewEndpoint;
  dispatch: Dispatch;
  type: string;
  week: number;
  year: number;
}

interface State {
  meals: any[];
  selectedMeal: any;
}

class ReviewForm extends React.Component<Props, State> {
  objectId: number;

  constructor(props) {
    super(props);
    const { loopBackEndpoint, rowData } = this.props;

    this.objectId = -1;

    if (rowData) {
      this.objectId = rowData[loopBackEndpoint.getIndexKey()];
    }

    this.state = {
      meals: [],
      selectedMeal: null
    };

    this.getMeals = this.getMeals.bind(this);
    this.setMeal = this.setMeal.bind(this);
  }

  performAction() {
    const { loopBackEndpoint, state, stateKey } = this.props;
    const changed = this.props.form.getFieldsValue();

    let api_data: any = {
      created_by: this.props.auth.user.first_name + ' ' + this.props.auth.user.last_name,
      camasys_dish_id: this.state.selectedMeal.camasys_id,
      camasys_delivery_id: this.state.selectedMeal.camasys_delivery_id,
      camasys_dish_name: this.state.selectedMeal.name,
      app_id: 'logistics',
      driver_id: this.props.auth.user.driver!.id
    };

    api_data = Object.assign({}, api_data, changed);

    if (api_data.remarks) {
      if (api_data.portion) {
        api_data.remarks += ' :: ' + api_data.portion;
      }
    } else if (api_data.portion) {
      api_data.remarks = ':: ' + api_data.portion;
    }

    const promise =
      this.props.type === 'edit'
        ? this.props.loopBackEndpoint.update(api_data, this.props.rowData)
        : this.props.loopBackEndpoint.create(api_data);

    promise
      .then(() => {
        this.props.dispatch(setLoading(stateKey, true));
        this.props.dispatch(fetchTable(stateKey, loopBackEndpoint.getEndPoint(), state.filters));

        Swal({
          title: 'Beoordeling opgeslagen',
          text: `De beoordeling is succesvol opgeslagen`,
          type: 'success',
          confirmButtonText: 'Ok'
        });
      })
      .catch(() => {
        setLoading(stateKey, false);
        Swal({
          title: 'Helaas',
          text: `Er is iets mis gegaan bij het opslaan van de beoordeling`,
          type: 'error',
          confirmButtonText: 'Ok'
        });
      });
  }

  componentDidMount() {
    if (this.props.type === 'edit') {
      this.getMeals(this.props.rowData.week);
    }
  }

  getMeals(weekNumber: number) {
    websiteClient.getDishes(weekNumber).then((result) => {
      // ensure array is unique
      const _result: any = [];
      const map = new Map();
      for (const item of result) {
        if (!map.has(item.camasys_id)) {
          map.set(item.camasys_id, true);
          _result.push({
            camasys_id: item.camasys_id,
            name: item.name,
            dish_number: item.dish_number_display_name,
            camasys_delivery_id: item.camasys_delivery_id
          });
        }
      }
      this.setState({ meals: _result });

      if (this.props.type === 'edit' && this.state.selectedMeal === null) {
        this.setState({
          selectedMeal: _result.filter(
            (_meal) => _meal.camasys_id === this.props.rowData.camasys_dish_id
          )[0]
        });
      }
    });
  }

  setMeal(meal) {
    this.setState({
      selectedMeal: this.state.meals.filter((_meal) => _meal.camasys_id === meal)[0]
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      style: { marginTop: 20 },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    };

    let week1 = moment().isoWeek();
    let week2 = moment().subtract(1, 'weeks').isoWeek();
    let week3 = moment().subtract(2, 'weeks').isoWeek();
    let week4 = moment().subtract(3, 'weeks').isoWeek();
    let week5 = moment().subtract(4, 'weeks').isoWeek();
    const desc = ['onder de maat', 'niet lekker', 'neutraal', 'goed', 'uitstekend'];

    return (
      <>
        <FormHeader
          type={this.props.type}
          newTitle='Maaltijdbeoordeling invoeren'
          editTitle='Maaltijdbeoordeling bewerken'
        />
        <Form {...formItemLayout}>
          <Form.Item label='Week'>
            {getFieldDecorator('week', {
              rules: [{ required: true, message: 'Kies een week' }],
              initialValue: this.props.type === 'edit' ? this.props.rowData.week : undefined
            })(
              <Select<number> placeholder='- Kies een week -' onChange={this.getMeals}>
                <Select.Option value={week1}>Week {week1}</Select.Option>
                <Select.Option value={week2}>Week {week2}</Select.Option>
                <Select.Option value={week3}>Week {week3}</Select.Option>
                <Select.Option value={week4}>Week {week4}</Select.Option>
                <Select.Option value={week5}>Week {week5}</Select.Option>
              </Select>
            )}
          </Form.Item>
          <Form.Item label='Maaltijd'>
            {getFieldDecorator('dish', {
              rules: [{ required: true, message: 'Kies een week' }],
              initialValue:
                this.props.type === 'edit' ? this.props.rowData.camasys_dish_id : undefined
            })(
              <Select placeholder='- Kies een maaltijd -' onChange={this.setMeal}>
                {this.state.meals.map((meal, index) => {
                  return (
                    <Select.Option key={index} value={meal.camasys_id}>
                      [{meal.dish_number}] {meal.name}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>
          <Form.Item label='Portie'>
            {getFieldDecorator('portion', {
              rules: [{ required: false }],
              initialValue:
                this.props.type === 'edit'
                  ? this.props.rowData.remarks.split('::').length > 1
                    ? this.props.rowData.remarks.split('::')[1].trim()
                    : undefined
                  : undefined
            })(
              <Select placeholder='- Maak een keuze -'>
                <Select.Option value='Small (350g)'>Small (350g)</Select.Option>
                <Select.Option value='Medium (450g)'>Medium (450g)</Select.Option>
                <Select.Option value='Large (650g)'>Large (600g)</Select.Option>
              </Select>
            )}
          </Form.Item>
          <Form.Item label='Beoordeling'>
            {getFieldDecorator('rating', {
              rules: [{ required: true, message: 'Voer een beoordeling in' }],
              initialValue: this.props.type === 'edit' ? this.props.rowData.rating : undefined
            })(<Rate tooltips={desc} allowClear={false} />)}
          </Form.Item>
          <Form.Item label='Opmerkingen'>
            {getFieldDecorator('remarks', {
              rules: [{ required: true, message: 'Voer een opmerking in' }],
              initialValue:
                this.props.type === 'edit'
                  ? this.props.rowData.remarks.split('::')[0].trim()
                  : undefined
            })(<TextAreaWithCharacterCount showCharacterCount maxLength={255} rows={8} />)}
          </Form.Item>
        </Form>
      </>
    );
  }
}

const mapStateToProps = ({ table, auth }, props) => {
  return {
    state: table.tables[props.stateKey],
    auth: auth
  };
};

export default connect(mapStateToProps)(Form.create()(ReviewForm));
